import { Router } from '@/routes'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import '@/styles/global.css'

function App() {
  return (
    <div className="!h-full">
      <GoogleReCaptchaProvider
        reCaptchaKey={import.meta.env.VITE_APP_RE_CAPTCHA}
        scriptProps={{
          async: true,
          appendTo: 'head'
        }}
      >
        <Router />
      </GoogleReCaptchaProvider>
    </div>
  )
}

export default App
